import React from "react";

import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";

export const placeholderTypes = Object.freeze({
  download: "placeholder-download",
  events: "placeholder-events",
  icon: "placeholder-icon",
  maps: "placeholder-events-map",
  news: "placeholder-news",
  "virtual-drive": "placeholder-virtual-drive",
});

interface ImagePlaceholderProps {
  aspectRatio?: number;
  className?: string;
  height?: number;
  typ?: keyof typeof placeholderTypes;
  width?: number;
}

const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({
  aspectRatio = 1,
  className = undefined,
  height = undefined,
  typ = undefined,
  width = 1920,
}) => {
  if (!height && !width) {
    return null;
  }

  const imageName = placeholderTypes[typ!] || "placeholder";

  const data = useStaticQuery<{ placeholderImages: Queries.FileConnection }>(graphql`
    {
      placeholderImages: allFile(filter: { name: { regex: "/placeholder/" } }) {
        nodes {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
          }
          name
        }
      }
    }
  `);

  const imageNode = data?.placeholderImages?.nodes.find((item) => item.name === imageName);

  if (!imageNode?.childImageSharp?.gatsbyImageData) {
    return null;
  }

  let calculatedHeight = 0;
  let calculatedWidth = 0;

  if (height && height > 0) {
    calculatedHeight = height;
  } else if (width && width > 0) {
    calculatedHeight = width / aspectRatio;
  }

  if (width && width > 0) {
    calculatedWidth = width;
  } else if (height && height > 0) {
    calculatedWidth = height / aspectRatio;
  }

  const image: IGatsbyImageData = {
    ...imageNode.childImageSharp.gatsbyImageData,
    height: calculatedHeight,
    width: calculatedWidth,
  };

  return (
    <div className="p-absolute w-100 h-100">
      <GatsbyImage
        image={image}
        alt="Placeholder"
        className={classNames("p-absolute w-100 h-100", className)}
        objectPosition="50%"
        objectFit="contain"
      />
    </div>
  );
};

export default ImagePlaceholder;
